import { Link } from 'react-router-dom';
import { mangaCategories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-flower-line text-primary-500 text-xl"></i>
              </div>
              <span className="text-base font-heading font-bold text-foreground-950">
                樱花动漫之家
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              聚合热门日本漫画资讯，涵盖日漫推荐与排行。从经典到最新连载，满足你的日漫追更和探索需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <Link to="/about" className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="space-y-2.5">
              {mangaCategories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="space-y-2.5 text-sm text-foreground-600">
              <p>邮箱：contact@sakuranga.com</p>
              <p>反馈：support@sakuranga.com</p>
              <div className="flex items-center gap-3 pt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 樱花动漫之家 Sakuranga.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}